//this is for the mobile version =. It's only display for screens with smaller width
import React, { useEffect, useState, useContext } from "react";

//styling
import "./clusterRow.css";

//helper functions
import { getIndividualClusterInfo } from "./helpers";

//global state
import { StateContext } from "../../AppStateContext";

//components
import ClustersViewMobileContent from "./ClustersViewMobileContent";
import ClusterRowMobileInfoPlaceholder from "./ClusterRowMobileInfoPlaceholder";

const ClusterRowMobileInfo = ({ cluster, setClusters, clusters }) => {
  //info about each cluster
  const [clusterInfo, setClusterInfo] = useState(null);

  const clustersListUrl = `${window.consoleConfig.wcs}/v1/clusters/${cluster}`;
  const access_token = JSON.parse(localStorage.getItem("access_token"));

  //access global state
  const state = useContext(StateContext);

  //to get data from each individual cluster
  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getIndividualClusterInfo(clustersListUrl, access_token, setClusterInfo);
    }

    const interval = setInterval(() => {
      getIndividualClusterInfo(clustersListUrl, access_token, setClusterInfo);
    }, 8000);

    return () => {
      clearInterval(interval);
      mounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token]);

  if (clusterInfo && clusterInfo.data) {
    return (
      <div
        className={
          state.theme === "dark"
            ? "__clusterRowMobileInfo __clusterRowMobileInfoDark"
            : "__clusterRowMobileInfo __clusterRowMobileInfoLight"
        }
      >
        <ClustersViewMobileContent
          clusterInfo={clusterInfo}
          clusters={clusters}
          setClusters={setClusters}
        />
      </div>
    );
  } else {
    return <ClusterRowMobileInfoPlaceholder />;
  }
};

export default ClusterRowMobileInfo;
